












































import { Component, Prop, Vue } from 'vue-property-decorator';
import customizableItinerariesQuery from '@/graphql/itinerary/CustomizableItineraries.query.gql';
import addSectionItemToItineraryMutation from '@/graphql/itinerary/AddSectionItemToItinerary.mutation.gql';
import { getEntityTypeByTypename } from '@/helpers/entityType';
import ThePlusIcon from '@/components/icons/ThePlusIcon.vue';
import TheMapWithMarkerIcon from '@/components/icons/TheMapWithMarkerIcon.vue';

const PER_PAGE = 9;

@Component({
  components: {
    TheMapWithMarkerIcon,
    ThePlusIcon,
    CreateItineraryModal: () => import('@/components/itinerary/CreateItineraryModal.vue'),
  },
  apollo: {
    customizableItineraries: {
      query: customizableItinerariesQuery,
      variables() {
        return {
          excludedEvents: this.eventIdentifier.id ? [this.eventIdentifier] : [],
          limit: PER_PAGE,
          nextCursor: this.nextCursor,
        };
      },
      result(result: any) {
        this.itineraries.push(...result.data.customizableItineraries.data);

        this.$nextTick(() => {
          const loadState = this.$refs.infiniteLoad?.stateChanger;
          if (!loadState) {
            return;
          }

          if (this.customizableItineraries.hasMorePages) {
            loadState.loaded();
          } else {
            loadState.complete();
          }
        });
      },
    },
  },
})
export default class AddToItineraryModalBody extends Vue {
  @Prop() event!: any;

  public customizableItineraries: any;
  public itineraries: any = [];
  public nextCursor: string | null = null;

  public isShowModal = false;
  public attachingItineraryId: number | null = null;

  get fetchingItineraries() {
    return this.$apollo.queries.customizableItineraries.loading;
  }

  get showListScroll() {
    return this.itineraries.length >= PER_PAGE;
  }

  get eventIdentifier() {
    if (!this.event) {
      return { id: null, type: null };
    }
    return { id: +this.event.id, type: this.event.__typename };
  }

  get hasMoreData(): boolean {
    return this.customizableItineraries && this.customizableItineraries.hasMorePages;
  }

  loadMore(state: any) {
    if (this.hasMoreData) {
      this.nextCursor = this.customizableItineraries.nextCursor;
      return;
    }
    state.complete();
  }

  toggleCreateModal() {
    this.isShowModal = !this.isShowModal;
  }

  addToItinerary(itinerary: any) {
    if (this.attachingItineraryId !== null) {
      return;
    }

    this.attachingItineraryId = itinerary.id;

    this.$apollo
      .mutate({
        mutation: addSectionItemToItineraryMutation,
        variables: {
          itineraryId: itinerary.id,
          entityId: this.eventIdentifier.id,
          entityType: this.eventIdentifier.type,
        },
      })
      .then(() => {
        this.$toast.success(
          `The ${getEntityTypeByTypename(this.eventIdentifier.type)} has been added to the Itinerary.`
        );
        this.$emit('added', { itineraryId: itinerary.id, itineraryTitle: itinerary.title });
      })
      .catch(() => {
        this.$toast.error('Failed to add the item to this Itinerary.');
      })
      .finally(() => {
        this.attachingItineraryId = null;
      });
  }

  afterItineraryCreated(data: any) {
    this.isShowModal = false;
    if (data) {
      this.itineraries.unshift(data);
    }
  }
}
